<mat-button-toggle-group [value]="selectedScope"
                        [disabled]="disabled"
                        class="w-100"
                        (change)="onChangeScope($event)">
  <mat-button-toggle *ngFor="let option of field?.options || []"
                    class="w-100"
                    [value]="option.value">
    {{ option.name }}
  </mat-button-toggle>
</mat-button-toggle-group>

<span class="color--gray txt-14 d-block mt-0012" *ngIf="selectedScope !== null">
  <button type="button"
          class="link p-0"
          [matMenuTriggerFor]="followUpFlagDueMenu">
          <span *ngIf="selectedDueDateMode === 'any' || selectedDueDateMode === null">With or without</span>
          <span *ngIf="selectedDueDateMode === 'having'">With</span>
          <span *ngIf="selectedDueDateMode === 'not_having'">Without</span>
  </button>
  <mat-menu #followUpFlagDueMenu="matMenu">
    <button mat-menu-item
            type="button"
            (click)="onDueDateModeChanged('any')">With or without</button>
    <button mat-menu-item
            type="button"
            (click)="onDueDateModeChanged('having')">With</button>
    <button mat-menu-item
            type="button"
            (click)="onDueDateModeChanged('not_having')">Without</button>
  </mat-menu>
  a due date<span *ngIf="selectedDueDateMode === 'having'">, </span>
  <ng-container *ngIf="selectedDueDateMode === 'having'">
    <button type="button"
            class="link p-0"
            [matMenuTriggerFor]="followUpFlagDueSpanMenu">
            <span *ngIf="selectedDueDateSpecial === null">due anytime</span>
            <span *ngIf="selectedDueDateSpecial === 'today'">due today</span>
            <span *ngIf="selectedDueDateSpecial === 'within'">due within&hellip;</span>
            <span *ngIf="selectedDueDateSpecial === 'past_due'">past due only</span>
            <span *ngIf="selectedDueDateSpecial === 'after_now'">after today only</span>
    </button>
    <mat-menu #followUpFlagDueSpanMenu="matMenu">
      <button mat-menu-item
              type="button"
              (click)="onDueDateSpecialChanged(null)">due anytime</button>
      <button mat-menu-item
              type="button"
              (click)="onDueDateSpecialChanged('today')">due today</button>
      <button mat-menu-item
              type="button"
              (click)="onDueDateSpecialChanged('within')">due within&hellip;</button>
      <button mat-menu-item
              type="button"
              (click)="onDueDateSpecialChanged('past_due')">past due only</button>
      <button mat-menu-item
              type="button"
              (click)="onDueDateSpecialChanged('after_now')">after today only</button>
    </mat-menu>
  </ng-container>
</span>

<div class="mt-0050"
     style="max-width:300px"
     *ngIf="selectedDueDateMode === 'having' && selectedDueDateSpecial === 'within'">
  <mat-form-field class="col__ col__xs--25 mb-0 compact">
    <input matInput
           type="tel"
           autocomplete="off"
           name="relativeOffsetUnits"
           [ngModel]="relativeOffsetUnits"
           [ngModelOptions]="{standalone: true}"
           (ngModelChange)="onRelativeOffsetUnitsChanged($event)"
           [disabled]="disabled">
  </mat-form-field>
  <mat-form-field class="col__ col__xs--50 compact mb-0 ml-0050">
    <mat-select placeholder="Days"
                [value]="relativeOffsetPeriod"
                [disableRipple]="true"
                name="relativeOffsetPeriod"
                (selectionChange)="onRelativeOffsetPeriodChanged($event.value)"
                [disabled]="disabled">
      <mat-option value="days">Days</mat-option>
      <mat-option value="weeks">Weeks</mat-option>
      <mat-option value="months">Months</mat-option>
    </mat-select>
  </mat-form-field>
</div>
